import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { Layout } from "@/components/layout/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { LegacyRedirect } from "@/components/LegacyRedirect";

import Home from "@/pages/Home";
import Domestic from "@/pages/Domestic";
import Commercial from "@/pages/Commercial";
import LineMarking from "@/pages/LineMarking";
import ProductDetail from "@/pages/ProductDetail";
import Clubs from "@/pages/Clubs";
import Service from "@/pages/Service";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import BookAssessment from "@/pages/BookAssessment";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import RepairsWinter from "@/pages/RepairsWinter";

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/domestic" element={<Domestic />} />
              <Route path="/commercial" element={<Commercial />} />
              <Route path="/line-marking" element={<LineMarking />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/clubs" element={<Clubs />} />
              <Route path="/service" element={<Service />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/book-assessment" element={<BookAssessment />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/cookies" element={<Cookies />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/lp/repairs-winter-storage" element={<RepairsWinter />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="*" element={<LegacyRedirect />} />
          </Routes>
        </BrowserRouter>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
